module.exports = __webpack_public_path__ + "static/img/dataserviceIndex_6.b0b31032.svg";